/**
 * @generated SignedSource<<9cf1efc0d95ac868a879af67362a445b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentFragment$data = {
  readonly created_by: string;
  readonly extension: string;
  readonly id: string;
  readonly name: string;
  readonly order: number | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "AttachmentFragment";
};
export type AttachmentFragment$key = {
  readonly " $data"?: AttachmentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttachmentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created_by",
      "storageKey": null
    }
  ],
  "type": "Attachment",
  "abstractKey": null
};

(node as any).hash = "99f35638e4952e34766dd5615a7cf551";

export default node;
